import React, { useState } from 'react';
import { Select } from 'antd';
import Text from 'components/Text';
import { Container } from './styles';
import DownTriangleIcon from './icons/DownTriangleIcon';
import UpTriangleIcon from './icons/UpTriangleIcon';
import clearIcon from './icons/clear-circle-icon.svg';

const DropdownSelect = ({
  id,
  defaultValue,
  clearable,
  label,
  menuItems,
  mode,
  handleSelect,
  handleSelectValue,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [value, setValue] = useState(null);
  const [showClearIcon, toggleShowClearIcon] = useState(false);
  const { Option } = Select;

  const handleChange = (value, item) => {
    let index;
    if (item && !Array.isArray(item)) {
      index = parseInt(item.key.slice(-1));
    }

    setValue(value);
    handleSelectValue && handleSelectValue(label, value);
    handleSelect && handleSelect(index);
  };

  const handleMouseEnter = () => (value ? toggleShowClearIcon(true) : toggleShowClearIcon(false));

  const menu = menuItems.map((item, index) => (
    <Option value={item} key={`dropdown-select--${index}`}>
      <Text
        data-testid={id && `dropdownselect-${id}-${index}`}
        type="p"
        size="normal"
        color="Neutral 5"
        marginMobile="0px"
      >
        {item}
      </Text>
    </Option>
  ));

  return (
    <Container className="dropdown-select--container">
      <Select
        id={id}
        data-testid={id && `dropdownselect-${id}`}
        defaultValue={defaultValue}
        suffixIcon={
          showClearIcon ? null : dropdownVisible ? <UpTriangleIcon /> : <DownTriangleIcon />
        }
        placeholder={
          <Text type="p" color="Neutral 4" marginMobile="0px">
            {label}
          </Text>
        }
        mode={mode}
        allowClear={clearable}
        onChange={handleChange}
        showArrow
        onDropdownVisibleChange={() => setDropdownVisible(!dropdownVisible)}
        {...(clearable
          ? {
              onMouseEnter: () => handleMouseEnter(),
              onMouseLeave: () => toggleShowClearIcon(false),
              clearIcon: <img src={clearIcon} className={showClearIcon ? 'show' : null} />,
              onClear: () => toggleShowClearIcon(false),
            }
          : {})}
      >
        {menu}
      </Select>
    </Container>
  );
};

export default DropdownSelect;
